import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from "../../../config";

@Component({
  selector: 'app-component-page-header',
  templateUrl: './component-page-header.component.html',
  styleUrls: ['./component-page-header.component.scss']
})
export class ComponentPageHeaderComponent implements OnInit {
  AppConfig: any;

  constructor() { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/component-page-header/component-page-header.component.ts